import React from 'react'
import { Views } from '../../views'
import { connect } from 'react-redux'
import { get } from 'lodash'

const ErrorByCase = ({ keycloak }) => {
    const { ErrorByCase } = Views

    return (
        <ErrorByCase keycloak={keycloak} />
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, 'keycloak', ''),
})

export default connect(mapStateToProps)(ErrorByCase)